import ReactDOM from "react-dom/client";

import type { ReactNode } from "react";

export function createWidgetMap() {
  const roots = new WeakMap<Node, ReactDOM.Root>();

  return {
    mountWidgetRoot(content: ReactNode): HTMLDivElement {
      const dom = document.createElement("div");
      const root = ReactDOM.createRoot(dom);
      roots.set(dom, root);
      root.render(content);
      return dom;
    },

    unmountWidgetRoot(node: Node): void {
      setTimeout(() => {
        roots.get(node)?.unmount();
        roots.delete(node);
      }, 0);
    },
  };
}

export type WidgetMap = ReturnType<typeof createWidgetMap>;
